import React, {useEffect, useState} from "react";
import classes from "./questions.module.css";
import {IMG, OPT_LABEL, TEXTBOX} from "../utils/constants";
import Skeleton from "react-loading-skeleton";
import {ReactComponent as FULL_SCREEN} from "../images/full-screen-icon.svg";
import {ReactComponent as DELETE} from "../images/trash_red.svg";
import {YuJaImageViewer} from "../components/standardization/YuJaImageViewer";

export default function OptionImageViewer({choice, imageURL, handleDelete}) {
    const [isLoading, setIsLoading] = useState(true);
    const [showViewModal, setShowViewModal] = useState(false);
    const [isMouseEnter, setIsMouseEnter] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        setShowViewModal(false);
        setIsMouseEnter(false);
        if (!!imageURL) {
            const img = new Image();
            img.src = imageURL;
            img.onload = () => setIsLoading(false);
            img.onerror = () => console.error('Failed to load image');
        }

    }, [ imageURL]);

    if (!imageURL) {
        return <></>;
    }

    if (isLoading) {
        return (
            <div className={classes.optionImageViewerWrapper} style={{display: "unset"}}>
                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={6}/>
            </div>
        );
    }

    return (
        <>
            <YuJaImageViewer
                showViewer={showViewModal}
                setShowViewer={setShowViewModal}
                onHandleClose={() => setShowViewModal(false)}
                imageURL={imageURL}
            />
            <div
                className={classes.optionImageViewerWrapper}
                onMouseEnter={() => setIsMouseEnter(true)}
                onMouseLeave={() => setIsMouseEnter(false)}
            >
                <div className={classes.optionImageViewer}>
                    <img
                        role={TEXTBOX}
                        src={imageURL}
                        alt={`${OPT_LABEL}${choice} ${IMG}`}
                    />
                </div>

                {isMouseEnter &&
                    <div
                        style={{
                            background: "#00000026", position: "absolute",
                            top: 0, left: 0, width: "100%", height: "100%", zIndex: 1,
                            display: "flex", padding: 3, flexDirection: "column",
                        }}
                    >
                        <span
                            className={classes.optionImageFullScreenIcon}
                            onClick={() => setShowViewModal(true)}
                            style={{alignSelf: "end"}}
                        >
                            <FULL_SCREEN/>
                        </span>
                        <span style={{flex: 1}}/>

                        <span
                            className={classes.optionImageFullScreenIcon}
                            onClick={handleDelete}
                            style={{alignSelf: "center"}}
                        >
                            <DELETE/>
                        </span>
                    </div>
                }
            </div>
        </>
    );
}